import { createAction, props } from '@ngrx/store';
import { ContenidoDePagos } from 'src/app/pago/models/ContenidoDePagos.model';

export const getContenido = createAction(
  '[Content] Cargar contenido',
  props<{ tenant: string; producto: string }>()
);

export const contenidoLoaded = createAction(
  '[Content] El contenido fue cargado',
  props<{ contenido: ContenidoDePagos }>()
);

export const getContenidoFailure = createAction(
  '[Content] Falló la carga de contenido',
  props<{ errorMessage: string }>()
);
